module.exports = __webpack_public_path__ + "img/empty-image-horizontal.ab6982a.png";